import CaEnglishTest from "@/components/icons/CaEnglishTest.tsx";
import ChannelLogo from "@/components/icons/registration/ChannelLogo.tsx";
import ConfirmEmailLogo from "@/components/icons/registration/ConfirmEmailLogo.tsx";
import DobIcon from "@/components/icons/registration/DobIcon.tsx";
import FinishLogo from "@/components/icons/registration/FinishLogo.tsx";
import LanguageIcon from "@/components/icons/registration/LanguageIcon.tsx";
import PasswordLogo from "@/components/icons/registration/PasswordLogo.tsx";
import ProfessionIcon from "@/components/icons/registration/ProfessionIcon.tsx";
import StartDateLogo from "@/components/icons/registration/StartDateLogo.tsx";

interface RegistrationIconProps {
  name: string;
}

const RegistrationIcon = ({ name }: RegistrationIconProps) => {
  switch (name) {
    case "language":
      return <LanguageIcon className="w-[48px] md:w-[66px] h-auto" />;
    case "dob":
      return <DobIcon className="w-[48px] md:w-[66px] h-auto" />;
    case "profession":
      return <ProfessionIcon className="w-[48px] md:w-[66px] h-auto" />;
    case "channel":
      return <ChannelLogo className="w-[48px] md:w-[66px] h-auto" />;
    case "password":
      return <PasswordLogo className="w-[48px] md:w-[66px] h-auto" />;
    case "email":
      return <ConfirmEmailLogo className="w-[48px] md:w-[66px] h-auto" />;
    case "date":
      return <StartDateLogo className="w-[48px] md:w-[66px] h-auto" />;
    case "finish":
      return <FinishLogo className="w-[48px] md:w-[66px] h-auto" />;
    case "english-test":
      return <CaEnglishTest className="w-[48px] md:w-[66px] h-auto" />;
    default:
      return null;
  }
};

export default RegistrationIcon;
